import 'regenerator-runtime/runtime';
import { configureStore, Middleware } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { config } from '../config';
import posthogMiddleware from './middleware/posthogMiddleware';
import socketMiddleware from './middleware/socketMiddleware';
import chartMogulMiddleware from './middleware/chartMogulMiddleware';
import i18nMiddleware from './middleware/i18nMiddleware';

const isDebug = !!config.debug;
const sagaMiddleware = createSagaMiddleware();

const customMiddleware: Middleware[] = [
  sagaMiddleware,
  posthogMiddleware,
  socketMiddleware,
  chartMogulMiddleware,
  i18nMiddleware,
  ...(isDebug ? [createLogger({ diff: true }) as Middleware] : []),
];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(customMiddleware),
  devTools: isDebug ? { trace: true, traceLimit: 25 } : false,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
